
/* UTILS SCRIPT */

window.isSmartphone = function() {

    if ($(window).width() < 768) {
	return true;
    } else {
	return false;
    }

}

window.isTabletPortrait = function() {

    if ($(window).width() >= 768 && $(window).width() < 1024) {
	return true;
    } else {
	return false;
    }

}

window.isTabletLandscape = function() {

    if ($(window).width() >= 1024 && $(window).width() < 1280) {
	return true;
    } else {
	return false;
    }

}

window.isTabletLandscapeSkin = function() {

    if ($(window).width() >= 1024 && $(window).width() <= 1280) {
	return true;
    } else {
	return false;
    }

}

window.isDesktop = function() {

    if ($(window).width() >= 1280 && $(window).width() < 1600) {
	return true;
    } else {
	return false;
    }

}

window.isDesktopSkin = function() {

    if ($(window).width() > 1281 && $(window).width() < 1600) {
	return true;
    } else {
	return false;
    }

}

window.isDesktopWideSkin = function() {

    if ($(window).width() >= 1600 ) {
	return true;
    } else {
	return false;
    }

}

window.isDesktopWide = function() {

    if ($(window).width() >= 1600) {
	return true;
    } else {
	return false;
    }

}

window.trunkArray = function(array,n){
    var array_limit = [];
    $.each(array,function(i,v){
        if(i>(n-1)) {return;}
        array_limit.push(v);
    });
    return array_limit;
}

window.trim = function (s, c) {
  if (c === "]") c = "\\]";
  if (c === "\\") c = "\\\\";
  return s.replace(new RegExp(
    "^[" + c + "]+|[" + c + "]+$", "g"
  ), "");
}

var UTILS = {
    regExp:{
        emailegMail: /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
    },
    verifyMail: function(email){
        return this.regExp.emailegMail.test(email);
    },
    createCookie: function(name,value,time){
        console.log("!!! CREATE COOKIE "+name);
        var expires = "";
        if (time) {
            var date = new Date();
            date.setTime(date.getTime() + (time*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + ";domain=.rds.it;path=/";
    },
    getCookie: function (name) {
	var re = new RegExp(name + "=([^;]+)");
        var value = re.exec(document.cookie);
        return (value != null) ? unescape(value[1]) : null;
    },
    deleteCookie: function(name){
        console.log("!!! DELETE COOKIE "+name);
        document.cookie = name + '= ; expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.rds.it;path=/';
    },
    popupCenter: function(url, title, w, h){
	// Fixes dual-screen position                         Most browsers      Firefox
	var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
	
	width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
	
	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
	
	// Puts focus on the newWindow
	if (window.focus) {
	    newWindow.focus();
	}
    },
    verifyDate: function(data){
	// formato data: dd/mm/yyyy
	var regexData = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
        return regexData.test(data);
    },
    logInfo: function(tag,text){
        var dt = new Date();
        console.info("["+pad(dt.getHours(),2)+":"+pad(dt.getMinutes(),2)+":"+pad(dt.getSeconds(),2)+"] "+"("+tag+") "+text);
    },
    decimalPoint: function(nStr){
        nStr += '';
	x = nStr.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
	    x1 = x1.replace(rgx, '$1' + '.' + '$2');
	}
	return x1 + x2;
    },
    getParameterByName: function(name, url) {
	
	if (!url) {
	    url = window.location.search;
	}

	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	    results = regex.exec(url);

	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
	
    }
};


window.removeskin = function(){
    $("#toggleskindiv").html("Mostra la skin");
    $("#skinPh").hide();
    $("main").removeClass("main-with-skin");
    $("html").removeClass("with-skin");
  $('.skin-container').hide();

  removeskinPost();
    onResizePage();
}

window.showskin = function(){
    $("#skinPh").html();
    $("#toggleskindiv").html("Nascondi la skin");
    $("#skinPh").show();
    $("main").addClass("main-with-skin");
    $("html").addClass("with-skin");
    $('.skin-container').show();
    
    showskinPost();
    onResizePage();
    const navHeight=$('#sticky_nav').height();
    const mainTop=document.body.clientWidth / 12;
    if(!$('#rds-main').hasClass("main-with-skin")){
      $('#rds-main').height("");
    }else{
      $('#rds-main').height(document.body.clientHeight - navHeight - mainTop);
    }
}

window.toggleskin = function(el){
    if($(el).text()=='Mostra la skin'){showskin();}
    else{removeskin();}
    onResizePage();
}


window.removeskinPost = function(){
    $("#toggleskindiv").html("Mostra la skin");
    $("#skinPh").hide();
    $('.skin-container').hide();
  $("html").removeClass("with-skin");


//    $("#rds-section-main").css("margin-top","auto");
//    $("#rds-section-main").css("margin-left","auto");
//    $("#rds-section-main").css("margin-right","auto");
//    $("#rds-section-main").css("width","calc(100vw - 521px)");
    $("main").removeClass("main-with-skin-post");
}

window.showskinPost = function(){
    $("#toggleskindiv").html("Nascondi la skin");
    $("#skinPh").show();
    $("main").addClass("main-with-skin-post");
}


window.removeLeaderboard = function(){ 
    $("#leaderboardPh").css("height","0px");
    $(".adv_leaderboard").css("margin-top","0%");
}

window.showLeaderboard = function(){
    $("#leaderboardPh").css("height","90px");
    $(".adv_leaderboard").css("margin-top","2%");
}


window.removeLeaderboardMobile = function(){ 
    $("#leaderboarmobiledPh").css("height","0px");
}

window.showLeaderboardMobile = function(){
    $("#leaderboarmobiledPh").css("height","90px");
}

window.removeSkyscraper = function(){ 
    $(".section-page-magazine").css("width","100%");
}

window.showSkyscraper = function(){
    console.log('showskyscraper');
    $(".section-page-magazine").css("width","68%");
}

window.removeSpaceRightPost = function(){ 
    console.log('*********');
}

window.showSpaceRightPost = function(){
    $(".section-page-magazine").css("width","68%");
}

window.toggleskinPost = function(el){
    if($(el).text()=='Mostra la skin'){showskinPost();}
    else{removeskinPost();}
}

window.removeMpu = function () {
    $('.mpu-news').hide();
}

window.removeSkyscraper = function(){

}

window.onResizePage = function(){ 
//     $("article.contents-single").css('width',200+'px');
    var w = $("#homepage-article-elaborated").width();
    if(w){
        var nelem = Math.floor(w/270);
        var aelem = $("#homepage-article-elaborated .colonna-home").length;
        var perc = 100/nelem;
        
        if(nelem!=aelem){
            if(nelem==1){
                $("#homepage-article").show();
                $("#homepage-article-elaborated").empty();
            }else{
                $("#homepage-article").hide();
                $("#homepage-article-elaborated").empty();
                for(var i=0;i<nelem;i++){
                    $("#homepage-article-elaborated").append("<div class='colonna-home' style='width:calc("+perc+"% - 3px);' id='homepage-article-elaborated-"+i+"'></div>");
                }
                //var mpu='<div id="mpuPh" style="width: calc(100% - 20px);" class="adv_mpu contents-single"></div>';
                var mpu='<div id="mpuPh" style="width:100%;" class="adv_mpu contents-single"></div>';
                
                $("#homepage-article-elaborated-"+(nelem-1)).append(mpu);
                
                
                $("#homepage-article article.contents-single").each(function(index,value){
                    var column = (index%nelem);
                    $(value).clone().appendTo("#homepage-article-elaborated-"+column);
                });
                
            }
        }
    }
    
    w=$("#category-article-elaborated").width();
    if(w){
        var nelem = Math.floor(w/270);
        var aelem = $("#category-article-elaborated .colonna-home").length;
        var perc = 100/nelem;
        
        if(nelem!=aelem){
            if(nelem==1){
                $("#category-article").show();
                $("#category-article-elaborated").empty();
            }else{
                $("#category-article").hide();
                $("#category-article-elaborated").empty();
                for(var i=0;i<nelem;i++){
                    $("#category-article-elaborated").append("<div class='colonna-home' style='width:calc("+perc+"% - 3px);' id='category-article-elaborated-"+i+"'></div>");
                }
                //var mpu='<div id="mpuPh" style="width: calc(100% - 20px);" class="adv_mpu contents-single"></div>';
                var mpu='<div id="mpuPh" style="width:100%;" class="adv_mpu contents-single"></div>';
                $("#category-article-elaborated-"+(nelem-1)).append(mpu);
                
                
                $("#category-article article.contents-single").each(function(index,value){
                    var column = (index%nelem);
                    $(value).clone().appendTo("#category-article-elaborated-"+column);
                });
                
            }
        }
    }
}

window.onResizePage2 = function(){ 
    var w = $("#homepage-article").width();
    if(w){
        var nelem = Math.floor(w/270);
        var nw = Math.floor(w/nelem);
//        console.log(nelem+"colonne");
//        var perc = 100/nelem;
        if(nelem>1){
            $("article.contents-single").css('width',(nw-15)+'px');
        }else{
            $("article.contents-single").css('width','calc(100% - 10px)');
        }
        $("article.contents-single").css('height','auto');
        $("article.contents-single").css('margin-top','auto');
        if(nelem==1){return;}
        
        var altezzaTutto = $("#homepage-article").height();
        
        var interv = setInterval(function(){
            console.log(altezzaTutto);
            var nuovaAltezzaTutto = $("#homepage-article").height();
            if(altezzaTutto!=nuovaAltezzaTutto){altezzaTutto=nuovaAltezzaTutto;}
            else{
                $("article.contents-single").css('position','absolute');
                clearInterval(interv);
                var max=[];
                max[0]=0;
                var x=0;
                var y=0;
                $("article.contents-single").each(function(index,value){
                    $(value).css('top',y);
                    $(value).css('left',x);
                    
                    var row = Math.floor(index/nelem);
                    if(max[row] === undefined){max[row]=0;}

                    $(value).data('riga',row);
                    var h = $(value).outerHeight(false);
                    if(h>max[row]){max[row]=h;};

                });
                $("article.contents-single").each(function(index,value){
                    var row = Math.floor(index/nelem);
//                    console.log("Riga "+row+" altezza: "+max[row]);
//                    $(value).css('height',max[row]+'px');
                });
                
                
//                $("article.contents-single").each(function(index,value){
//                    var row = Math.floor(index/nelem);
//                    var mh = max[row];
//                    var h = $(value).outerHeight(false);
//                    var spazio = mh-h;
//                    if(spazio>0){
////                        console.log($("article.contents-single").eq(index+nelem));
////                        $("article.contents-single").eq(index+nelem).css('margin-top','-'+spazio+"px");
//                        console.log("spazio sotto "+spazio);
//                    }
////                    console.log("spazio sotto "+spazio);
//                });
                
            }
        },100);
       
    }
}

var actualAlert = window.alert;

window.alert =  function(msg){

  try{
      
    console.log(msg); 
    $(".rds-modal-popup-box").css("width", "262px");
    $(".rds-modal-popup-box").css("height", "auto");
    $("#rds-popup-content").html(window.templates["alert-ok"]);
    $("#rds-alert-ok-msg").html(msg); 
    RDSMODALPOPUP.open();
    
  } catch(err){
    return actualAlert(msg);
  }
  
};

window.alertError = function (msg) {

    try {

    	console.log(msg);
	$(".rds-modal-popup-box").css("width", "262px");
	$(".rds-modal-popup-box").css("height", "auto");
	$("#rds-popup-content").html(window.templates["alert-ko"]);
	$("#rds-alert-ko-msg").html(msg);
	RDSMODALPOPUP.open();
	
	WEBTREKK_DL.sendEvent('errore', {2: msg});

    } catch (err) {
	return actualAlert(msg);
    }

};

window.pad = function(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}


window.isPageNative = function(pathname) {

    //Assetto ADV pagine native
    //0:solo SKIN-MPU
    //1:solo LEADERBOARD-MPU 
    //2:solo LEADERBOARD
    //3:solo SKIN
    //4:solo LEADERBOARD-MPU-SKYSCRAPER
    //5:solo MPU
    //6:solo SKIN-LEADERBOARDMOBILE
    //7:solo SKIN-MPU-LEADERBOARD

    try {

	var pagineNativeOBJ = JSON.parse($("#pagine-native-obj").html());

	/*
	 //lista pagina native
	 var pagineNativeOBJ = [
	 {"url":"/minisito/rds-play-on-tour-winter-edition-2018/443499", "typeAdDisplay": 0},
	 {"url":"/minisito/rds-play-on-tour-winter-edition-2018/443626", "typeAdDisplay": 0},
	 //{"url":"/scopri/magazine/cinema/sconnessi", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/rds-consiglia/adotta-un-ragazzo", "typeAdDisplay": 3},
	 {"url":"/giochi/il-sole-a-mezzanotte", "typeAdDisplay": 2},
	 {"url":"/giochi/hostiles", "typeAdDisplay": 2},
	 {"url":"/giochi/escobar-il-fascino-del-male", "typeAdDisplay": 2},
	 {"url":"/scopri/magazine/cinema/arrivano-i-prof", "typeAdDisplay": 2},
	 {"url":"/scopri/magazine/cinema/solo-a-star-wars-story", "typeAdDisplay": 1},
	 {"url":"/giochi/the-strangers-prey-at-night", "typeAdDisplay": 2},
	 {"url":"/scopri/magazine/eventi/lestate-chiama-swatch-e-rds-rispondono", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/vacanze-in-sardegna", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/viaggiare-in-crociera-si-o-no", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/degusticous-un-evento-unico-per-un-mare-di-emozioni", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/casa-bacardi-summer-tour-2018", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/keglevich-pure-attraction", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/con-bravo-bio-vinci-lincanto-della-natura", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/cisalfa", "typeAdDisplay": 4},
	 {"url":"/scopri/magazine/segui-la-gamma-renault-in-tour-scopri-la-tappa-piu-vicina", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/segui-la-gamma-renault-in-tour-scopri-la-tappa-piu-vicina", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/gli-incredibili-2", "typeAdDisplay": 5},
	 {"url":"/minisito/rds-play-on-tour-summer-edition-2018/456237", "typeAdDisplay": 0},
	 {"url":"/minisito/rds-play-on-tour-summer-edition-2018/456241", "typeAdDisplay": 5},
	 {"url":"/minisito/rds-play-on-tour-summer-edition-2018/456246", "typeAdDisplay": 0},
	 {"url":"/minisito/rds-play-on-tour-summer-edition-2018/456250", "typeAdDisplay": 4},
	 {"url":"/scopri/magazine/cinema/ant-man-and-the-wasp/", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/cinema/mamma-mia-ci-risiamo/", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/cinema/ritorno-al-bosco-dei-100-acri/", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/rds-consiglia/gli-incredibili-2-al-cinema", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/rds-consiglia/w-il-pollo", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/carne-di-pollo-che-passione-e-lei-la-preferita-dagli-uomini-italiani", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/nonni-e-nipoti-uniti-anche-a-tavola-grazie-al-pollo-parola-di-esperti", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/i-numeri-del-pollo", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/leggera-sana-e-facile-da-cucinare-la-carne-di-pollo-e-la-piu-amata-dalle-donne", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/tante-proteine-pochi-grassi-e-poche-calorie-il-pollo-e-lalleato-n-1-degli-sportivi", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/bufale-no-grazie-tutte-le-verita-sul-pollo", "typeAdDisplay": 0},
	 {"url":"/giochi/hell-fest", "typeAdDisplay": 2},
	 {"url":"/scopri/magazine/cinema/lo-schiaccianoci-e-i-quattro-regni", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/eventi/on-hair-show-exhibition", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/cinema/se-son-rose", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/cinema/un-piccolo-favore", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/cinema/il-ritorno-di-mary-poppins", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/eventi/lumbria-e-la-tradizione-dei-presepi", "typeAdDisplay": 6},
	 {"url":"/scopri/magazine/eventi/tieni-il-tempo-con-halls-gum", "typeAdDisplay": 3},
	 {"url":"/scopri/magazine/cinema/ralph-spacca-internet/", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/cinema/ralph-spacca-internet", "typeAdDisplay": 1},
	 {"url":"/giochi/moschettieri-del-re-la-penultima-missione", "typeAdDisplay": 3},
	 {"url":"/scopri/magazine/cinema/non-ci-resta-che-il-crimine/", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/cinema/non-ci-resta-che-il-crimine", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/eventi/mini-rds-super-g-2019/", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/eventi/mini-rds-super-g-2019", "typeAdDisplay": 0},
	 {"url":"/rds-social-tv", "typeAdDisplay": 3},
	 {"url":"/scopri/magazine/cinema/compromessi-sposi", "typeAdDisplay": 1},
	 {"url":"/scopri/magazine/rds-consiglia/il-viaggio-dei-sogni-una-crociera-sul-mediterraneo", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/rds-consiglia/il-viaggio-dei-sogni-una-crociera-sul-mediterraneo/", "typeAdDisplay": 0},
	 {"url":"/minisito/rds-play-on-tour-winter-edition-2019/475741", "typeAdDisplay": 5},
	 {"url":"/minisito/rds-play-on-tour-winter-edition-2019/475768", "typeAdDisplay": 0},
	 {"url":"/scopri/magazine/cinema/unavventura", "typeAdDisplay": 1},
	 {"url":"/giochi/vinci-la-proiezione-del-film-the-vanishing-il-mistero-del-faro", "typeAdDisplay": 2},
	 {"url":"/scopri/magazine/rds-consiglia/il-mediterraneo-e-un-museo-allaria-aperta", "typeAdDisplay": 0}
	 ]; 
	 */

	var isNative = -1;
	for (var i = 0, l = pagineNativeOBJ.length; i < l; i++) {
	    if (pathname.indexOf(pagineNativeOBJ[i].url) >= 0) {
		isNative = pagineNativeOBJ[i].typeAdDisplay;
	    }

	}

    } catch (e) {
	    return -1;
    }

    return isNative;
}

window.checkPasswordGiaImpostata = function(data){
    
    var login_email = data.content.login_email;

    var data = {
	email: login_email
    };
    
    showWaitingLoader();
    
    API.post("community/check_password_gia_impostata", data, function (resp) {
	
	hideWaitingLoader();
	
	// se ho già impostata la password in precedenza, faccio il redirect sulla pagina profile
	if (resp.status == 0){
	    USER.signIn();
	    addNavigation("/profile?mail=" + login_email);
	}
	
    });
}

window.fbLoginWk = function(){
    FB.login(function (fbloginresp) {
        console.log(fbloginresp);
        if (fbloginresp.status === 'connected') {
            USER.loginFacebookAuth(fbloginresp.authResponse);
        }else{
            hideWaitingLoader();
        }
    }, {
        scope: 'public_profile,email'
    });
}

window.replaceUrlSezioneScopri = function(data){
    //window.history.pushState("replaceUrlSezioneScopri", "replaceUrlSezioneScopri", data.path_corretto);
    location.href = data.path_corretto;
}

$(document).on('keypress', '#cerca-localita',function(e) {
    if(e.which == 13) {
        replaceNavigation('/viabilita/' + $("#cerca-localita").val());
    }
});

